<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/ccdsregmeetingtop.png" class="img" />
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/regtitleimg.png" class="modeltitleimg" />
                    <div class="modeltitletext">注册费</div>
                </div>
            </div>

            <table class="maintable" cellspacing="0">
                <tr style="background-image: linear-gradient(to right, rgb(12,15,115), rgb(12,37,215));">
                    <th class="inth">普通<br />参会</th>
                    <th class="inth">专委会<br />会员</th>
                    <th class="inth">住院<br />医师</th>
                    <th class="inth" style="width: 29%;">团队优惠<br /><span class="sspan">普通参会</span><br /><span
                            class="sspan">（含ACMED会员）</span></th>
                    <th class="inth">团队优惠<br /><span class="sspan">住院医师</span></th>
                </tr>
                <tr>
                    <td class="intd center">800元/人</td>
                    <td class="intd center">600元/人</td>
                    <td class="intd center">400元/人</td>
                    <td class="intd center" style="width: 29%;">400元/人</td>
                    <td class="intd center">200元/人</td>
                </tr>
            </table>
            <div class="ziti" style="font-weight: bold;">*免注册费对象:上海本地参会医生且提前预录信息、大会角色嘉宾、学生（带相关证件现场注册）</div>
            <div class="ziti">会员为:中国医药教育协会皮肤与健康教育专业委员会会员<br />*注册费包含会议资料费用，会议期间午餐由大会统一安排。住宿交通自理</div>
            <!-- <div class="ziti"></div> -->
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/regtitleimg.png" class="modeltitleimg" />
                    <div class="modeltitletext">注册通道</div>
                </div>
            </div>
            <!-- <div class="neirong ziti">本次大会团队注册【10人（含）以上】，请直接联系</div> -->
            <!-- <div class="preple ziti">刘老师：15800797187</div> -->
        </div>

        <div class="model">
            <img src="../../assets/images/ccdsjfqr.png" class="qrimg" />
        </div>
        <floatback />
    </div>
</template>

<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'ccdsregmeeting',
    data() {
        return {
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initccdsShare();
        document.title = "CCDS第四届中国皮肤外科大会";
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(0, 61, 155);
    border-bottom-left-radius: 50rem;
}

.modeltitle {
    background: rgb(20, 21, 139);
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
    background: #fff;
    border-radius: 50rem;
    width: 0.5rem;
    height: 0.5rem;
    box-sizing: border-box;
    padding: 0.05rem;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.maintable {
    width: 100%;
    margin: 0.4rem 0;
    font-size: .32rem;
}

.intd {
    padding: .2rem 0;
    border: 1px solid rgb(190, 211, 246);
    width: 18%;
}

.inth {
    padding: .1rem 0;
    // background: rgb(0, 54, 134);
    color: #fff;
    border: 1px solid rgb(190, 211, 246);
    width: 18%;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(0, 54, 134);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .35rem;
}

.qrimg {
    display: block;
    margin: auto;
    width: 40%;
    margin-top: 1rem;
}

.sspan {
    font-size: .28rem;
    font-weight: initial;
}
</style>